module.exports = __webpack_public_path__ + "img/vector-success.a737fe8b.png";